// extracted by mini-css-extract-plugin
export default {"container":"ApprovePointCampaignDetail_container__BQRIa","wrapperTable":"ApprovePointCampaignDetail_wrapperTable__PAglH"};